import { createContext, useCallback, useEffect, useMemo, useState } from 'react';
import { IntlProvider } from 'react-intl';
import { useCookies } from 'react-cookie';
import PropTypes from 'prop-types';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers';
import moment from 'moment/moment';
import msgFr from 'config/msg/fr/messages.json';
import errFr from 'config/msg/fr/errors.json';
import { getDateFnsLocale } from 'utils/formatTime';

export const LocaleContext = createContext('fr-FR');

const getMessages = (locale) => {
  if (locale && locale.startsWith('en')) {
    // return {...msgEn, ...errEn};
  }
  return { ...msgFr, ...errFr };
};

LocaleProvider.propTypes = {
  children: PropTypes.node
};

function LocaleProvider({ children }) {
  // eslint-disable-next-line no-unused-vars
  const [cookies, setCookie] = useCookies(['locale']);
  // const initialLocale = cookies.locale
  //   ? cookies.locale
  //   : navigator.language || navigator.userLanguage;

  const initialLocale = 'fr';

  const [locale, setLocale] = useState(initialLocale);
  const [messages, setMessages] = useState(getMessages(initialLocale));

  const onLocaleChange = useCallback(
    (newLocale) => {
      setLocale(newLocale);
      setCookie('locale', newLocale, { path: '/' });
      setMessages(getMessages(newLocale));
    },
    [setCookie]
  );

  const memoizedValue = useMemo(
    () => ({
      locale,
      onLocaleChange
    }),
    [locale, onLocaleChange]
  );

  useEffect(() => {
    moment.locale(locale);
  }, [locale]);

  return (
    <LocaleContext.Provider value={memoizedValue}>
      <IntlProvider
        messages={messages}
        locale={locale}
        onError={(err) => {
          if (err.code === 'MISSING_TRANSLATION') {
            console.warn('Missing translation', err.message);
            return;
          }
          throw err;
        }}
      >
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={getDateFnsLocale(locale)}>
          {children}
        </LocalizationProvider>
      </IntlProvider>
    </LocaleContext.Provider>
  );
}

export default LocaleProvider;
